import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
/**
 * Get Permissions.
 *
 * @param dispatch
 */
export function getPermissions(_ref) {
  var dispatch = _ref.dispatch;
  dispatch('api', {
    url: 'permissions',
    commitAfter: 'permissions/PERMISSIONS',
    wait: 'get-permissions'
  }, {
    root: true
  });
}

/**
 * Store new Permission.
 *
 * @param commit
 * @param dispatch
 * @param data
 * @returns {Promise|Q.Promise<any>|Promise<any>|PromiseLike<any>}
 */
export function storePermission(_ref2, data) {
  var commit = _ref2.commit,
    dispatch = _ref2.dispatch;
  return dispatch('api', {
    url: 'permissions',
    method: 'post',
    data: data,
    wait: 'store-permission'
  }, {
    root: true
  }).then(function (response) {
    commit('PERMISSION', response.data);
    return Promise.resolve(response);
  });
}

/**
 * Get specific permission by ID.
 *
 * @param state
 * @param commit
 * @param dispatch
 * @param id
 * @returns {*}
 */
export function getPermission(_ref3, id) {
  var state = _ref3.state,
    commit = _ref3.commit,
    dispatch = _ref3.dispatch;
  return dispatch('api', {
    url: 'permissions/' + id,
    wait: 'get-permission'
  }, {
    root: true
  }).then(function (response) {
    commit('PERMISSION', response.data);
  });
}

/**
 * Update permission.
 *
 * @param commit
 * @param dispatch
 * @param data
 * @returns {*}
 */
export function updatePermission(_ref4, data) {
  var commit = _ref4.commit,
    dispatch = _ref4.dispatch;
  return dispatch('api', {
    url: 'permissions/' + data.id,
    method: 'put',
    data: data.form,
    wait: 'update-permission',
    files: true,
    commitAfter: 'permissions/PERMISSION'
  }, {
    root: true
  });
}

/**
 * Delete permission.
 *
 * @param commit
 * @param dispatch
 * @param id
 * @returns {*}
 */
export function deletePermission(_ref5, id) {
  var commit = _ref5.commit,
    dispatch = _ref5.dispatch;
  return dispatch('api', {
    url: 'permissions/' + id,
    method: 'delete',
    wait: 'delete-permission'
  }, {
    root: true
  });
}